export function flatten(data: any, maxDepth: number = null, roots: any[] = [], depth: number = 0): any {
  return Object.keys(data).reduce((previous, key) => {
    let current: any;

    if (Object.prototype.toString.call(data[key]) === '[object Object]' && (maxDepth === null || (maxDepth !== null && depth < maxDepth))) {
      current = flatten(data[key], maxDepth, roots.concat([key]), depth + 1);
    } else {
      current = { [roots.concat([key]).join('.')]: data[key] };
    }

    return Object.assign({}, previous, current);
  }, {});
}
